import { CalendarMinusIcon, PlanLocationIcon, UserIcon } from '@repo/icons';
import { tr } from '@repo/locale';
import { useLocation, useNavigate } from 'react-router-dom';
import { TestId } from '@repo/test-id';
import { useHasActiveReservations } from '@repo/domain-service';

import { selectCanSeeSupportPhone, selectStatus, useAuthStore, useHeldRolesStore } from '@features/auth';

import BottomBarButton from '@shared/components/bottomBar/BottomBarButton';
import { findActiveRoute } from '@shared/utils/findActiveRoute';
import { SUPPORT_EMAIL, SUPPORT_PHONE_NUMBER } from '@shared/constants/constants';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function BottomBar() {
  const testId = TestId.root('bottomBar');
  const navigate = useNavigate();

  const isLoggedIn = useAuthStore(selectStatus) !== 'unauthenticated';
  const { hasActiveReservations } = useHasActiveReservations(isLoggedIn);
  const canSeeSupportPhone = useHeldRolesStore(selectCanSeeSupportPhone);

  const reservationsRoute = ROUTE_PATHS[RouteName.ACCOUNT_RESERVATIONS];
  const mapRoute = ROUTE_PATHS[RouteName.MAP];
  const accountRoute = ROUTE_PATHS[RouteName.ACCOUNT];

  const { pathname } = useLocation();
  const activeRoute = findActiveRoute(pathname, [reservationsRoute, mapRoute, accountRoute]);

  const handleReservationsClick = () => {
    navigate(reservationsRoute);
  };
  const handleMapNavigation = () => {
    navigate(mapRoute);
  };
  const handleAccountClick = () => {
    navigate(accountRoute);
  };

  return (
    <div className="bg-primary shadow-bottom-bar border-stroke-base-subtle flex items-center justify-between border-t pr-4 pl-4 drop-shadow-2xl drop-shadow-black/30">
      <div className="flex w-full justify-between md:ml-15 md:w-150">
        <BottomBarButton
          isActive={activeRoute === reservationsRoute}
          icon={CalendarMinusIcon}
          name={tr('bottom_bar.reservations')}
          testId={testId.append('reservationsButton')}
          onClick={handleReservationsClick}
          showDot={hasActiveReservations}
        />
        <BottomBarButton
          isActive={activeRoute === mapRoute}
          icon={PlanLocationIcon}
          name={tr('bottom_bar.park')}
          testId={testId.append('parkButton')}
          onClick={handleMapNavigation}
        />
        <BottomBarButton
          isActive={activeRoute === accountRoute}
          icon={UserIcon}
          name={tr('bottom_bar.account')}
          testId={testId.append('accountButton')}
          onClick={handleAccountClick}
        />
      </div>
      <div className="text-brand-strong hidden text-right text-sm md:block">
        {canSeeSupportPhone && (
          <>
            <a href={`tel:${SUPPORT_PHONE_NUMBER}`}>{SUPPORT_PHONE_NUMBER}</a>
            <br />
          </>
        )}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
      </div>
    </div>
  );
}
